import { render, staticRenderFns } from "./FBAContainerOrder.vue?vue&type=template&id=0215f530&scoped=true"
import script from "./FBAContainerOrder.vue?vue&type=script&lang=js"
export * from "./FBAContainerOrder.vue?vue&type=script&lang=js"
import style0 from "./FBAContainerOrder.vue?vue&type=style&index=0&id=0215f530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215f530",
  null
  
)

export default component.exports